import React, { StrictMode } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import useReportTemplates from 'components/Common/ReportTemplates/Hooks/useReportTemplates';

import routes from 'app/routes';
import List from './Pages/List/Index';
import NewReport from './Pages/New/Index';
import EditReport from './Pages/Edit/Index';
import RunReport from './Pages/Run/Index';

export default function Index() {
  const [reportTemplates, refresh] = useReportTemplates();

  const router = createBrowserRouter([
    {
      path: routes.admin.report_templates.index,
      element: <List reportTemplates={reportTemplates} refresh={refresh} />,
      children: [
        {
          path: routes.admin.report_templates.run(),
          element: <RunReport />,
        },
      ],
    },
    {
      path: routes.admin.report_templates.new,
      element: <NewReport refresh={refresh} />,
    },
    {
      path: routes.admin.report_templates.edit(),
      element: <EditReport />,
    },
  ]);

  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
